import CustomCard from '../../../../../../components/CustomCard';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import { DocumentationIcon, TrashIcon, TrashOutlineIcon } from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import NotInformation from '../../../../../../components/NotInformation';
import { CustomCheckbox } from '../../../../../../components/CustomCheckbox';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsItem = ({
    t,
    list,
    selectedList,
    isAllChecked,
    handleCheckboxChange,
    handleDeleteAll,
    title = 'work_shift',
    showNoInformation = true,
    onDelete = null,
    iconDelete = true,
    TitleIcon = DocumentationIcon,
    setSelectedList,
    setDeleteWorkShiftsModal
}) => {
    return (
        <>
            <CustomCard classes={'w-100'} classCard={'card-border-8px'}>
               <div className='d-flex align-items-center m-3'>
                    {TitleIcon && <TitleIcon className='w-h-24px' />}
                    {title !== '' && <p className='fs-16px ibl-font-w-600 font-color-general-950 py-3'>{t(title)}</p>}
                    <ButtonAction
                        id='btn_wst_delete'
                        name='delete'
                        className='btn-icon-delete ms-auto'
                        Icon={TrashOutlineIcon}
                       disabled={selectedList?.length === 0}
                        onClick={() => setDeleteWorkShiftsModal(true)}
                    />
                </div>
                {list?.length > 0 && (
                    <div className={'mb-3'}>
                        <CustomCheckbox
                            id={'cb_wsi_de_select_all'}
                            trans={t('de_/_select_all')}
                            checked={isAllChecked}
                            onChange={handleDeleteAll}
                            marginbutton={true}
                        />
                    </div>
                )}
                {list?.length > 0 ? (
                    <>
                        {list?.map((item, index) => (
                            <div className='mb-2 px-0' id={`id_${item?.id || index}`} key={`key_${item?.id || index}`}>
                                <CustomCard classes='w-100' classCard='card-shades-300-100' classContent='p-10px'>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <CustomCheckbox
                                                id={item?.id}
                                                checked={selectedList?.includes(item?.id)}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                            <p className='fs-14px ibl-font-w-600 font-color-general-950'>
                                                {item?.name || EMPTY_VALUES.DEFAULT}
                                            </p>
                                        </div>
                                        {iconDelete && (
                                            <div
                                            onClick={()=>{
                                                if(onDelete) onDelete(index);
                                                }}
                                            >
                                            <TrashIcon className="icon-color-shades-400 icon-hover-shades-950" width={16} height={16} />
                                            </div>
                                        )}
                                    </div>
                                </CustomCard>
                            </div>
                        ))}
                    </>
                ) : (
                    <>{showNoInformation && <NotInformation text={t('no_work_shifts_added_yet')} card={true} />}</>
                )}
            </CustomCard>
        </>
    );
};

export default WorkShiftsItem;
